import { render, staticRenderFns } from "./Similares.vue?vue&type=template&id=817d769c&scoped=true"
import script from "./Similares.vue?vue&type=script&lang=js"
export * from "./Similares.vue?vue&type=script&lang=js"
import style0 from "./Similares.vue?vue&type=style&index=0&id=817d769c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817d769c",
  null
  
)

export default component.exports